import { adminApiFetch } from './apiService';

export const ecAccountService = {
  // 列表
  fetchList: async () => {
    const response = await adminApiFetch('ec_accounts.json', { method: 'GET' });
    return response.json();
  },

  // 獲取列表 (TableIndex 用)
  getRecords: async (params) => {
    const response = await adminApiFetch('ec_accounts/get_records', {
      method: 'POST',
      body: params
    });
    return response.json();
  },

  // 獲取單個
  get: async (id) => {
    const response = await adminApiFetch(`ec_accounts/${id}`);
    return response.json();
  },

  // 創建
  create: async (data) => {
    const response = await adminApiFetch('ec_accounts', {
      method: 'POST',
      body: { ec_account: data }
    });
    return response.json();
  },

  // 更新
  update: async (id, data) => {
    const response = await adminApiFetch(`ec_accounts/${id}`, {
      method: 'PATCH',
      body: { ec_account: data }
    });
    return response.json();
  },

  // 刪除
  delete: async (id) => {
    const response = await adminApiFetch(`ec_accounts/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  // 撤銷 Shopify 授權
  revokeShopify: async (id) => {
    const response = await adminApiFetch(`ec_accounts/${id}/shopify/revoke`, {
      method: 'DELETE'
    });
    return response.json();
  },

  // 撤銷 Shopee 授權
  revokeShopee: async (id) => {
    const response = await adminApiFetch(`ec_accounts/${id}/shopee/revoke`, {
      method: 'DELETE'
    });
    return response.json();
  },

  // 測試連線
  testConnection: async (id) => {
    const response = await adminApiFetch(`ec_accounts/${id}/test_connection`, {
      method: 'POST'
    });
    return response.json();
  },

  // 獲取 Coupang 退貨地/發貨地清單
  getCoupangShippingInfo: async (id) => {
    const response = await adminApiFetch(`ec_accounts/${id}/coupang/shipping_info`);
    return response.json();
  },

  // 排程抓取訂單（將 next_run_at 更新為現在）
  scheduleFetch: async (id) => {
    const response = await adminApiFetch(`ec_accounts/${id}/schedule_fetch`, {
      method: 'POST'
    });
    return response.json();
  },

  // 同步對應商品主檔
  syncProductMappings: async (id) => {
    const response = await adminApiFetch(`ec_accounts/${id}/sync_product_mappings`, {
      method: 'POST'
    });
    return response.json();
  },

  // 手動同步庫存（絕對值覆寫平台庫存）
  syncStock: async (id) => {
    const response = await adminApiFetch(`ec_accounts/${id}/sync_stock`, {
      method: 'POST'
    });
    return response.json();
  }
};

export default ecAccountService;
